export default {
      id: "oc-res-monitor-dashboard-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-monitor-dashboard",
      toString: function () {
        return this.url;
      }
    }